import { Component, h, Prop, EventEmitter, Event } from '@stencil/core';
import { getModalWordings } from '../../utils/wordings';
import { getLanguage } from '../../utils/utils';

@Component({
    tag: 'popup-message-modal',
    styleUrl: 'popup-message-modal.scss',
    shadow: false
})
export class PopupMessageModal {

    // Props
    @Prop({ mutable: true, reflect: true })
    @Prop({ mutable: true, reflect: true }) message: string;
    @Prop() isOpen: boolean = false;
    @Prop() buttonIsClicked: boolean = false;
    @Prop() selectedProvince: string;
    private wordings = {};

    // Events
    @Event() private popupButtonAction: EventEmitter;

    // Functions
    private handleAction = () => {
        this.popupButtonAction.emit();
    }

    componentWillLoad() {
        const language = getLanguage();
        this.wordings = getModalWordings(language);
    }

    render() {
        return (
            <div id="popup-message-modal"
                class={this.isOpen ? 'modal-container is-open' : 'modal-container'}>


                {/* Wrapper */}
                <div class="rsm-popup-popup-wrapper">

                    {/* Container */}
                    <div class="rsm-popup-message-modal-container">

                        {/* Body */}
                     
                            <div class="rsm-popup-modal-body">
                                <p class="rsm-popup-message-modal-message">{this.message}</p>
                            </div>
                    
                        {/* Footer */}
                        <div class="rsm-popup-modal-buttons">
                            <div class="rsm-popup-modal-footer">
                                <regional-selector-button onClick={this.handleAction} buttonLabel={this.wordings['ok']} class="w-full"></regional-selector-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}